import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campSnNew: FaireAdCampaignEntity = {
  token: "camp_sn_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_strong_n_free",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 2000,
  startedRunningAt: "2025-11-03",
  segmentMetrics: {
    numCustomersAcquired: 39,
    salesDollars: 21500,
    totalAdsSpendDollars: 4769,
    cpaDollars: 122.28,
    bestEstimateSalesDollars: 25125,
    bestEstimateRoas: 5.27,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-25T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
